import {useFormContext} from 'react-hook-form';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
} from '@common-web/components/ui/form';
import {Input} from '@common-web/components/ui/input';
import {StateSelect} from './StateSelect';

export function AddressFields({basePath, required}: {basePath: string; required?: boolean}) {
  const {control} = useFormContext();
  // Purely visual — validation lives in rfcSchema.
  const mark = required ? ' *' : '';
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
      <FormField
        control={control}
        name={`${basePath}.street`}
        render={({field}) => (
          <FormItem>
            <FormLabel>Street{mark}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={control}
        name={`${basePath}.city`}
        render={({field}) => (
          <FormItem>
            <FormLabel>City{mark}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <StateSelect name={`${basePath}.state`} label={`State${mark}`} />
      <FormField
        control={control}
        name={`${basePath}.zip`}
        render={({field}) => (
          <FormItem>
            <FormLabel>Zip Code{mark}</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
